import {
  Loader,
  useMantineTheme,
} from "@mantine/core";
import {
  type NotificationData,
  notifications,
} from "@mantine/notifications";
import {
  IconInfoCircle,
  IconCircleCheck,
  IconAlertCircle,
  IconCircleX,
} from "@tabler/icons-react";
import { useCallback, useMemo, type FC } from "react";

type NotificationVariant = "info" | "success" | "warning" | "error" | "loading";

interface MapkaNotificationData extends NotificationData {
  variant: NotificationVariant;
}

const variantIcon: Record<NotificationVariant, FC<{ color: string }>> = {
  info: IconInfoCircle,
  success: IconCircleCheck,
  warning: IconAlertCircle,
  error: IconCircleX,
  loading: Loader,
};

export const useMapkaNotification = () => {
  const { colors } = useMantineTheme();

  const variantIconColors: Record<NotificationVariant, string> = useMemo(() => ({
    info: colors.info[5],
    success: colors.success[5],
    warning: colors.warning[4],
    error: colors.error[5],
    loading: colors.indigo[8],
  }), [colors]);

  return useCallback((notification: MapkaNotificationData) => {
    const { variant } = notification;

    const Icon = variantIcon[variant];
    const color = variantIconColors[variant];

    return notifications.show({
      ...notification,
      icon: <Icon color={color} />,
    });
  }, [variantIconColors]);
};
